import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';
import { ErrorInterceptor } from './error.interceptor';
import { HeadersInterceptor } from './headers.interceptor';
import {NeedSyncInterceptor} from '@app/core/interceptors/need-sync.interceptor';

/**
 * Defines the execution order of the HTTP interceptors
 */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: NeedSyncInterceptor, multi: true }
];
